import React from "react";
import { SearchFieldMultiple } from "./SearchFieldMultiple";
import { SearchFieldSingle } from "./SearchFieldSingle";
import { SearchFieldProps } from "../types";

type Props = SearchFieldProps & { searchFieldVariant?: "single" | "multiple" };

export const SearchField = React.forwardRef<unknown, Props>((
  props,
) => {
  const { searchFieldVariant, ...coreProps } = props;
  switch (searchFieldVariant) {
    case "multiple":
      return <SearchFieldMultiple {...coreProps} />;
    default:
      return <SearchFieldSingle {...coreProps} />;
  }
});
